import styles from "./info.module.css";

import { ArrowLeft2 } from "iconsax-react";

import { List, Stack, Text } from "@mantine/core";

interface GuideSection {
  heading: string;
  steps: string[];
}

interface SupportInfoProps {
  lists: GuideSection[];
  onBack: () => void;
  title: string;
}

export const SupportInfo = ({ lists, onBack, title }: SupportInfoProps) => {
  return (
    <div className={styles.container}>
      <ArrowLeft2
        color="#292D32"
        size={35}
        onClick={onBack}
        className={styles.backIcon}
      />
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.subtitle}>
        Welcome to {title}! Let’s get you set up and ready to explore all the
        amazing features we have to offer.
      </p>

      <div className={styles.contentWrapper}>
        <Text className={styles.noInfoText}>
          No setup information available.
        </Text>
        {lists.map((section) => (
          <Stack key={section.heading}>
            <Text fw="bold">{section.heading}</Text>
            <List listStyleType="disc">
              {section.steps.map((step) => (
                <List.Item key={step}>{step}</List.Item>
              ))}
            </List>
          </Stack>
        ))}
      </div>
    </div>
  );
};
